import cn from 'classnames';
import { useTranslations } from 'next-intl';
import { AiOutlineClockCircle } from 'react-icons/ai';

export interface ReadingTimeLabels {
  minute0: string;
  minute1: string;
  minute2: string;
  readingTime: string;
}

interface ReadingTimeProps {
  className?: string;
  content: string;
}

export default function ReadingTime({
  className,
  content,
}: ReadingTimeProps) {
  const t = useTranslations('main');
  const readingTime = t('posts.readingTime', {
    time: '[time]',
    rest: '[rest]',
  });
  const minute0 = t('posts.minute0');
  const minute1 = t('posts.minute1');
  const minute2 = t('posts.minute2');
  const words = content.split(' ').length;
  const time = Math.ceil(words / 160);

  const rest =
    time === 1 ? minute0 : time <= 4 ? minute1 : minute2;

  return (
    <div
      className={cn(
        'flex items-center text-premium-900 dark:text-orange-500',
        className,
      )}
    >
      <AiOutlineClockCircle className="mr-1 h-6 w-6" />
      {readingTime
        .replace('[time]', time.toString())
        .replace('[rest]', rest)}
    </div>
  );
}
